module.exports = __webpack_public_path__ + "static/media/ATCLogo_OnDark.ab1fe440.png";